export default __webpack_public_path__ + "d537674e9e217fa53a13cf9bcc7eaa62.woff2";